import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { dismissMorningPaper, getDismissalStatus } from "./morningPaperDismissalApi";

/**
 * Query hook to check if morning paper has been dismissed for today's business date.
 * The server calculates the business date in America/Chicago timezone.
 * Note: getDismissalStatus fails closed on error (returns dismissed: true) to avoid forcing logout.
 * @param enabled - Whether to enable the query
 */
export function useDismissalStatus(enabled = true) {
    return useQuery({
        queryKey: ["morningPaper", "dismissalStatus"],
        queryFn: () => getDismissalStatus(),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: false, // API function handles retries internally
        enabled,
    });
}

/**
 * Mutation hook to record morning paper dismissal for today's business date.
 * The server calculates the business date in America/Chicago timezone.
 * Invalidates the dismissal status query on success to prevent the morning paper
 * from briefly flashing when the expert goes Offline later (e.g., end of shift).
 */
export function useDismissMorningPaper() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => dismissMorningPaper(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["morningPaper", "dismissalStatus"] });
        },
    });
}
